import React from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'

interface DeleteReminderModalProps {
  open: boolean
  onClose: () => void
  reminderName: string
  onConfirm: () => void
  isLoading?: boolean
}

export const DeleteReminderModal: React.FC<DeleteReminderModalProps> = ({
  open,
  onClose,
  reminderName,
  onConfirm,
  isLoading = false,
}) => {
  const { t } = useTranslation()

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="gap-4 p-4 max-w-modal-sm">
        <DialogHeader>
          <DialogTitle className="m-0 text-lg font-semibold text-gray-light-900">
            {t('workflowConfig.deleteReminder.title')}
          </DialogTitle>
          <DialogDescription className="m-0 text-sm font-normal text-gray-light-600">
            {t('workflowConfig.deleteReminder.message', { name: reminderName })}
          </DialogDescription>
        </DialogHeader>

        <div className="flex gap-3 pt-2">
          <Button
            onClick={onClose}
            disabled={isLoading}
            className="flex-1 rounded-md py-2.5 px-xl font-semibold text-secondary-700 hover:text-secondary-hover text-sm border-solid border-primary bg-white hover:bg-primary-hover"
            variant="default"
          >
            {t('common.cancel')}
          </Button>
          <Button
            onClick={onConfirm}
            disabled={isLoading}
            className="flex-1 rounded-md py-2.5 px-xl font-semibold text-sm border-solid border-transparent !text-white !bg-error-solid disabled:!bg-disabled disabled:!text-disabled"
            variant="default"
          >
            {t('common.delete')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
